import { Container, Paper, useTheme } from '@material-ui/core';
import ConfirmationNumberIcon from '@material-ui/icons/ConfirmationNumber';
import React from 'react';
import { mainishStyles } from '../../styling';
import PageHeader from '../Common/PageHeader';
import LoginForm from './LoginForm';

export default function Home() {
  const mainishclasses = mainishStyles();
  const theme = useTheme();

  sessionStorage.clear();

  return (
    <>
      <Container maxWidth="sm">
        <PageHeader
          icon={
            <ConfirmationNumberIcon
              color={theme.palette.type === 'dark' ? 'secondary' : 'primary'}
            />
          }
          title="Cek Status"
          subTitle="Masukkan token yang telah Anda terima saat mengisi Form Pelayanan untuk melihat status tiket."
          className={mainishclasses.pageContent}
        />
        <Paper className={mainishclasses.pageContent}>
          <LoginForm />
        </Paper>
      </Container>
    </>
  );
}
